import { render, staticRenderFns } from "./Slideshow.vue?vue&type=template&id=8e84f4b4"
import script from "./Slideshow.vue?vue&type=script&lang=js"
export * from "./Slideshow.vue?vue&type=script&lang=js"
import style0 from "./Slideshow.vue?vue&type=style&index=0&id=8e84f4b4&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports